module.exports = __webpack_public_path__ + "img/kleos.243a1cb9.jpg";